import { GetRowIdParams, GridOptions } from '@ag-grid-community/core';

import { agProcessCellFromClipboard } from '@shared/utils/ag-copy-paste.utils';
import { Utils } from '@shared/utils/utils';

import DEFAULT_IN_MONTH_ADJUSTMENT_GRID_CONFIG from './ima-grid-default-config';
import { QuarterCloseAdjustmentGridData } from '../quarter-close-adjustments.model';
import { imaAttributesColumnGroup } from './ima-attributes-column-group';
import { imaCategoryColumnGroup } from './ima-category-column-group';
import { imaCurrentForecastColumnGroup } from './ima-current-forecast-column-group';
import { imaEvidenceBasedColumnGroup } from './ima-evidence-based-column-group';
import { InMonthAdjustmentGridConfigContext } from './ima-grid-config-context';
import { imaInvoiceColumnGroup } from './ima-invoice-column-group';
import { imaOverallBudgetColumnGroup } from './ima-overall-budget-column-group';
import { imaPreviousMonthColumnGroup } from './ima-previous-month-column-group';
import { imaTotalExpenseColumnGroup } from './ima-total-expense-colum-group';
import { imaVendorContractColumnGroup } from './ima-vendor-contract-column-group';
import { imaVendorEstimateColumnGroup } from './ima-vendor-estimate-column-group';
import { suppressKeyboardEvent } from './suppress-keyboard-event';

export const inMonthAdjustmentGridConfig = (
  ctx: InMonthAdjustmentGridConfigContext
): GridOptions<QuarterCloseAdjustmentGridData> => {
  const config = DEFAULT_IN_MONTH_ADJUSTMENT_GRID_CONFIG;

  return {
    ...config,
    columnDefs: [
      imaVendorContractColumnGroup(ctx),
      imaCategoryColumnGroup(ctx),
      imaAttributesColumnGroup(ctx),
      imaOverallBudgetColumnGroup(ctx),
      imaPreviousMonthColumnGroup(ctx),
      imaCurrentForecastColumnGroup(ctx),
      imaVendorEstimateColumnGroup(ctx),
      imaInvoiceColumnGroup(ctx),
      imaEvidenceBasedColumnGroup(ctx),
      imaTotalExpenseColumnGroup(ctx),
    ],
    defaultColDef: {
      ...config.defaultColDef,
      suppressKeyboardEvent: suppressKeyboardEvent(ctx),
    },
    getRowId: (params: GetRowIdParams) => params.data.activity_id,
    processCellForClipboard: (params) => {
      if (params.column.getColId() === 'tma_source') {
        return params.value;
      }

      if (params.column.getColId() === 'vendor_estimate_percent_ltd') {
        return params.value.vendor_estimate_percent_ltd;
      }

      return Utils.castStringToNumber(params.value).toString();
    },
    processDataFromClipboard: (params) => agProcessCellFromClipboard(params),
    processUnpinnedColumns: () => {
      return [];
    },
  };
};
